import { useQuery } from "@tanstack/react-query";

import type { ListSignatureRequestTemplatesResponseJSON } from "@performyard/service-contracts";

import {
	ListSignatureRequestTemplatesParams,
	getSignatureRequestTemplates,
} from "../../services/defs/signature-request-templates";
import type { PYUseQueryOptions } from "../StandardQueryArguments";

export const signatureRequestTemplatesKeys = {
	all: ["SignatureRequestTemplates"] as const,
	list: (params?: ListSignatureRequestTemplatesParams) =>
		[...signatureRequestTemplatesKeys.all, "list", params] as const,
};

export const useSignatureRequestTemplates = (
	params: ListSignatureRequestTemplatesParams = {},
	options?: PYUseQueryOptions<ListSignatureRequestTemplatesResponseJSON>
) => {
	return useQuery({
		queryKey: signatureRequestTemplatesKeys.list(params),
		queryFn: () => getSignatureRequestTemplates(params),
		meta: {
			errorMessage: "There was an error getting the signature request templates.",
		},
		...options,
	});
};
